'use strict';

require('@grpn/perflibloader/dist/boomerang-0.9.x');
